const bonusFromLevelAndFinesse = 'Damage is based on your level and receives bonus from Finesse.';
const bonusFromLevelAndIntelligence = 'Damage is based on your level and receives bonus from Intelligence.';
const bonusFromLevelAndStrength = 'Damage is based on your level and receives bonus from Strength.';
const bonusFromSummoning = 'The stats of the summons will depend on caster level and Summoning ability.';
const bonusFromWeaponAndFinesse = 'Damage is based on your basic attack and receives a bonus from Finesse.';
const bonusFromWeaponAndAttribute = 'Damage is based on your basic attack and receives a bonus from {attribute}.';

export const skillTitle = {
	duration: 'Duration {0} turn(s)',
	explanation: 'Welcome to the Workshop! Bits and pieces of the Skillbook feature might lie around here. Safety goggles advised!',
	forget: 'Forget',
	learn: 'Learn',
	radius: '{0}m Explode radius',
	range: '{0}m Range',
	rangeBonus: '+{0}m from {1}',
	requires: 'Requires {0} {1}',
	resistTypeArmorPhysical: 'Physical Armor',
	resistTypeArmorMagical: 'Magical Armor',
	resistedBy: 'Resisted by {0}',
	selectSkills: 'Select Skills',
	skillbar: 'Memorized',
	skillbook: 'Skillbook',
	slotCost: '{0} slot(s)',
	typeEquipment: 'Special',
	typeInnate: 'Innate',
	typeStory: 'Story Skill',
	typeSource: 'Sourcery',
	unableToMemorize: 'Unable to memorize. Increase memory slots or unlearn some skills.',
	unlockToEdit: 'Unlock skillbar to change skills.',
};

const aerotheurge = {
	apportation: 'Apportation',
	apportationDescriptionMd: 'Transport pickupable items in the target area into your inventory.',
	blessedSmokeCloud: 'Blessed Smoke Cloud',
	blessedSmokeCloudDescriptionMd: 'Conjure a cloud of thick blessed smoke that makes characters Invisible.',
	blindingRadiance: 'Blinding Radiance',
	blindingRadianceDescriptionMd: 'Enemies around you receive *Air Damage*. You receive a status that turns enemies in 5m radius Blind.',
	blindingRadianceDetails: `Set Blinding Radiance for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	breathingBubble: 'Breathing Bubble',
	breathingBubbleDescriptionMd:
		'Creates a bubble of clean air around your head, allowing you to ignore effects of cloud surfaces. ' +
		'Provides immunity to Suffocating and Silenced.',
	breathingBubbleDetails: 'Set Breathing Bubble for 5 turn(s).',
	chainLightning: 'Chain Lightning',
	chainLightningDescriptionMd:
		'Shoot a stunning bolt of lightning that forks up to 8 times in a 8m radius and deals *Air Damage* to each target.',
	chainLightningDetails: `Set Shocked for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	closedCircuit: 'Closed Circuit',
	closedCircuitDescriptionMd: 'Deals *Air Damage* to enemies around you; then creates cursed static clouds on the edge of the spell.',
	closedCircuitDetails: `Set Air Immunity for 1 turn(s).\nSet Shocked for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	dazingBolt: 'Dazing Bolt',
	dazingBoltDescriptionMd:
		'An electrical bolt falls from the sky, dealing *Air Damage* to characters in the area and setting Shocked status.',
	dazingBoltDetails: `Set Shocked for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	electricDischarge: 'Electric Discharge',
	electricDischargeDescriptionMd: 'An electrical jolt deals *Air Damage* to target character. Sets status Shocked.',
	electricDischargeDetails: `Set Shocked for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	erraticWisp: 'Erratic Wisp',
	erraticWispDescriptionMd:
		'Cause target character to teleport in a random direction each time they are attacked. Increases Air Resistance by 40%.',
	erraticWispDetails: 'Set Erratic Wisp for 2 turn(s).',
	evasiveAura: 'Evasive Aura',
	evasiveAuraDescriptionMd: 'For yourself and nearby allies, Dodging is increased by 90% and Movement Speed is increased by 1m.',
	evasiveAuraDetails: 'Set Evasive Aura for 1 turn(s).',
	favourableWind: 'Favourable Wind',
	favourableWindDescriptionMd:
		'Control the forces of nature, increasing the movement speed of you and your allies by 1.5m ' +
		'(as long as your allies stay within 10m of you).',
	favourableWindDetails: 'Set Favourable Wind Aura for 4 turn(s).',
	massBreathingBubbles: 'Mass Breathing Bubbles',
	massBreathingBubblesDescriptionMd:
		'Set Breathing Bubble on allies around you, allowing them to ignore cloud surfaces. Provides immunity to Suffocating and Silenced.',
	massBreathingBubblesDetails: 'Set Breathing Bubble for 5 turn(s).',
	netherSwap: 'Nether Swap',
	netherSwapDescriptionMd: 'Make two characters switch places. One of the characters can be you.',
	pressureSpike: 'Pressure Spike',
	pressureSpikeDescriptionMd: 'Condense all cloud surfaces in the area. Deals *Air Damage* to enemies and douses fire.',
	pressureSpikeDetails: bonusFromLevelAndIntelligence,
	shockingTouch: 'Shocking Touch',
	shockingTouchDescriptionMd: "Sets the Shocked status on a target within arm's length and deals *Air Damage*.",
	shockingTouchDetails: `Set Shocked for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	smokeCover: 'Smoke Cover',
	smokeCoverDescriptionMd: 'Create a smoke cloud around you, hiding you from sight.',
	superconductor: 'Superconductor',
	superconductorDescriptionMd: 'Shoot forking sparks at all enemies within the area, dealing *Air Damage* and setting Shocked.',
	superconductorDetails: `Set Shocked for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	teleportation: 'Teleportation',
	teleportationDescriptionMd: 'Teleportation a a Teleport a target character or item to a point of your choosing.',
	thunderstorm: 'Thunderstorm',
	thunderstormDescriptionMd: 'A storm rages in the target area, hitting enemies with lightning bolts, each dealing *Air Damage*.',
	tornado: 'Tornado',
	tornadoDescriptionMd:
		'A tornado moves randomly around the battlefield, removing surfaces and revealing invisible characters. ' +
		'Also clears Invisible, Burning and Slowed.',
	uncannyEvasion: 'Uncanny Evasion',
	uncannyEvasionDescriptionMd: "Target character's Dodging is increased by 90% and Movement Speed is increased by 20%.",
	uncannyEvasionDetails: 'Set Evading for 1 turn(s).',
	vacuumAura: 'Vacuum Aura',
	vacuumAuraDescriptionMd:
		'Deal *Air Damage* to enemies in the area. Caster receives an aura that sets Silence and Suffocating on enemies.',
	vacuumAuraDetails: `Set Vacuum Aura for 3 turn(s).\n${bonusFromLevelAndIntelligence}`,
	vacuumTouch: 'Vacuum Touch',
	vacuumTouchDescriptionMd: 'Deal *Air Damage*. Set Suffocation and Silence on target.',
	vacuumTouchDetails: `Set Suffocating for {suffocating} turn(s).\nSet Silenced for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	vaporise: 'Vaporise',
	vaporiseDescriptionMd:
		'Remove Petrified and Frozen from target character. Vaporise ground surfaces into clouds. Does not work on Oil, Ice or Lava surfaces.',
};

const geomancer = {
	acidSpores: 'Acid Spores',
	acidSporesDescriptionMd: 'Shoot 3 spores of corrosive acid, dealing *Poison Damage*.',
	acidSporesDetails: `Set Poisoned for {poisoned} turn(s).\n${bonusFromLevelAndIntelligence}`,
	contamination: 'Contamination',
	contaminationDescriptionMd:
		'Deals *Poison Damage* to enemies and undead allies around you and can poison them. Turns water, blood surfaces and clouds into poison!',
	contaminationDetails: `Set Poisoned for 3 turn(s).${bonusFromLevelAndIntelligence}`,
	corrosiveSpray: 'Corrosive Spray',
	corrosiveSprayDescriptionMd: 'Destroy *Physical Armour* on targets in a cone, and set Acid and Atrophy.',
	corrosiveSprayDetails: `Set Acid for {acid} turn(s).\nSet Atrophy for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	corrosiveTouch: 'Corrosive Touch',
	corrosiveTouchDescriptionMd: 'Destroy *Physical Armour* on target character, and set Acid status.',
	corrosiveTouchDetails: `Set Acid for {acid} turn(s).\n${bonusFromLevelAndIntelligence}`,
	dustBlast: 'Dust Blast',
	dustBlastDescriptionMd: 'Throw dust at all enemies in range, blinding them and dealing *Earth Damage*.',
	dustBlastDetails: `Set Blinded for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	earthquake: 'Earthquake',
	earthquakeDescriptionMd:
		'Deal *Earth Damage* and Knockdown enemy characters and items around you. ' +
		'Creates 8 random oil surfaces within the area.',
	earthquakeDetails: `Set Knocked Down for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	fortify: 'Fortify',
	fortifyDescriptionMd:
		'Provides *Physical Armour*. While Fortified, the target cannot be teleported. Removes Poisoned, Bleeding, Burning, Acid, Decaying.',
	fortifyDetails: 'Set Fortified for 3 turn(s).',
	fossilStrike: 'Fossil Strike',
	fossilStrikeDescriptionMd: 'A giant rock filled with sticky oil that deals *Earth Damage*. Creates an oil surface where it lands.',
	fossilStrikeDetails: bonusFromLevelAndIntelligence,
	impalement: 'Impalement',
	impalementDescriptionMd: 'Spikes impale all characters and items, setting Crippled and dealing *Earth Damage*. Also creates an oil puddle.',
	impalementDetails: `Set Crippled for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	livingWall: 'Living Wall',
	livingWallDescriptionMd: 'Vines sprout from the ground to block the path in a target area, emitting poison clouds around them.',
	massOilyCarapace: 'Mass Oily Carapace',
	massOilyCarapaceDescriptionMd: 'Each ally consumes oil surfaces around them, converting the oil surfaces to Physical Armour. Removes Slowed.',
	massOilyCarapaceDetails: 'Restore some Physical Armour, depending on relevant surface area.',
	mendMetal: 'Mend Metal',
	mendMetalDescriptionMd: 'Allies near to you start slowly regenerating Physical Armour.',
	mendMetalDetails: 'Restore Physical Armour for 3 turn(s).',
	oilyCarapace: 'Oily Carapace',
	oilyCarapaceDescriptionMd: 'Consume oil surfaces around you and convert them to Physical Armour. Removes Slowed.',
	oilyCarapaceDetails: 'Restore some Physical Armour, depending on relevant surface area.',
	poisonDart: 'Poison Dart',
	poisonDartDescriptionMd: 'Cast a magical poisonous dart that does *Poison Damage*, and creates a puddle of poison.',
	poisonDartDetails: `Set Poisoned for {poisoned} turn(s).${bonusFromLevelAndIntelligence}`,
	poisonWave: 'Poison Wave',
	poisonWaveDescriptionMd:
		'Poison erupts from the caster in a circular wave, dealing *Poison Damage* and forming poison clouds. ' +
		'Gives immunity to poison and earth damage for one turn.',
	poisonWaveDetails: `Set Earth Immunity for 1 turn(s). \n${bonusFromLevelAndIntelligence}`,
	pyroclasticEruption: 'Pyroclastic Eruption',
	pyroclasticEruptionDescriptionMd:
		'Multiple oil-filled rocks erupt from the caster at all enemies in the area. ' +
		'On impact, they create oil surfaces and deal *Earth Damage*.',
	pyroclasticEruptionDetails: bonusFromLevelAndIntelligence,
	reactiveArmour: 'Reactive Armour',
	reactiveArmourDescriptionMd:
		'Deal *Physical Damage*, based on your current Physical Armour, ' +
		'in a wave of metal spikes to everyone in the area (including yourself).',
	reactiveArmourDetails: 'Damage is based on your current Physical Armour.',
	siphonPoison: 'Siphon Poison',
	siphonPoisonDescriptionMd:
		'Siphon Poison Remove poison surfaces and clouds. Gain poison damage bonus to weapon attacks and weapon-based skills ' +
		'(dependent upon size of poison area cleared).',
	siphonPoisonDetails: 'Set Siphon Poison for 2 turn(s).',
	summonHungryFlower: 'Summon Hungry Flower',
	summonHungryFlowerDescriptionMd: 'Plant that can lob acidic spores and emit cursed poison clouds.',
	summonHungryFlowerDetails: bonusFromSummoning,
	throwDust: 'Throw Dust',
	throwDustDescriptionMd: 'Throw dust at a character, blinding them and dealing *Earth Damage*. Clears surfaces and clouds in the area.',
	throwDustDetails: `Set Blinded for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	turnToOil: 'Turn To Oil',
	turnToOilDescriptionMd: 'Turn water and blood surfaces into oil. Remove Stun and Shocked from characters.',
	venomCoating: 'Venom Coating',
	venomCoatingDescriptionMd: 'Coat your weapons with poison, adding *Poison Damage* to your weapon skills and attacks.',
	venomCoatingDetails: 'Set Venom Coating for 2 turn(s).',
	venomousAura: 'Venomous Aura',
	venomousAuraDescriptionMd: 'Allies in range receive Venom Coating, which adds *Poison Damage* to weapon skills and attacks.',
	venomousAuraDetails: 'Set Venom Aura for 4 turn(s).',
	wormTremor: 'Worm Tremor',
	wormTremorDescriptionMd:
		'Deals *Earth Damage* to each character in the area. At your command, poisonous worms slither up from the earth, ' +
		'attaching to every character in the area who is not protected by Magic Armour. Affected characters cannot move or, teleport, ' +
		'and they receive poison damage each turn.',
	wormTremorDetails: `Set Entangled for {entangled} turn(s).\n${bonusFromLevelAndIntelligence}`,
};

const huntsman = {
	arrowSpray: 'Arrow Spray',
	arrowSprayDescriptionMd: 'Fire 15 arrows in a 60 degree arc. Each arrow deals *Physical Damage*.',
	arrowSprayDetails: bonusFromWeaponAndAttribute,
	arrowStorm: 'Arrow Storm',
	arrowStormDescriptionMd: '15 arrows fall from the sky in target area, each dealing *Physical Damage*.',
	arrowStormDetails: bonusFromWeaponAndAttribute,
	assassinate: 'Assassinate',
	assassinateDescriptionMd:
		'Attack your target with meticulous aim, dealing *Physical Damage* in one shot. ' +
		'When performed from Stealth, this attack gains a 50% damage increase.',
	assassinateDetails: bonusFromWeaponAndAttribute,
	ballisticShot: 'Ballistic Shot',
	ballisticShotDescriptionMd: 'A shot that deals *Physical Damage* and receives 5% bonus damage per lm distance to target.',
	ballisticShotDetails: bonusFromWeaponAndAttribute,
	barrage: 'Barrage',
	barrageDescriptionMd: 'Fire three arrows at three targets of your choice, each dealing *Physical Damage*.',
	barrageDetails: bonusFromWeaponAndAttribute,
	elementalArrowheads: 'Elemental Arrowheads',
	elementalArrowheadsDescriptionMd:
		'Target a surface in melee radius. Elemental damage matching that surface is added to your ranged weapon attacks and ranged weapon-based skills.',
	farsight: 'Farsight',
	farsightDescriptionMd: "Increase the range of a target character's ranged attacks and skills by 4m.",
	farsightDetails: 'Set Farsight for 3 turn(s).',
	firstAid: 'First Aid',
	firstAidDescriptionMd: 'Heals target for some Vitality. Cures Crippled, Knocked Down, Blind, Silenced, Bleeding, Burning, Poisoned, Diseased.',
	firstAidDetails: 'Restore Vitality.\nSet Rested for 1 turn(s).',
	glitterDust: 'Glitter Dust',
	glitterDustDescriptionMd: 'Target is Marked, decreasing its ability to Dodge. Prevents target from going invisible.',
	glitterDustDetails: 'Set Marked for 3 turn(s).',
	marksmansFang: "Marksman's Fang",
	marksmansFangDescriptionMd: "Shoot an arrow that goes straight through enemies. Each enemy that's hit takes *Piercing Damage*, ignoring Armour.",
	marksmansFangDetails: bonusFromWeaponAndAttribute,
	pinDown: 'Pin Down',
	pinDownDescriptionMd: 'Deal *Physical Damage* and Cripple target character.',
	pinDownDetails: `Set Crippled for 1 turn(s).\n${bonusFromWeaponAndAttribute}`,
	reactiveShot: 'Reactive Shot',
	reactiveShotDescriptionMd: 'Target a circular area. Until your next turn, you will reflexively shoot at the first three enemies moving within this area.',
	reactiveShotDetails: 'Can only be cast in combat.\nSet Reactive Shot for 1 turn(s).',
	ricochet: 'Ricochet',
	ricochetDescriptionMd: 'Fire a normal arrow that deals *Physical Damage* and then finds another target within 5m. Forks up to 2 times.',
	ricochetDetails: bonusFromWeaponAndAttribute,
	skyShot: 'Sky Shot',
	skyShotDescriptionMd: 'Leap into the air before shooting, gaining damage bonuses for your superior height. Deals *Physical Damage*.',
	skyShotDetails: `This skill receives high ground bonuses regardless of elevation.\n${bonusFromWeaponAndAttribute}`,
	tacticalRetreat: 'Tactical Retreat',
	tacticalRetreatDescriptionMd: 'Become Hasted and then teleport to target position.',
	tacticalRetreatDetails: 'Set Hasted for 1 turn(s).',
};

const hydrosophist = {
	arcaneStitch: 'Arcane Stitch',
	arcaneStitchDescriptionMd:
		"Fully restore target character's Magic Armour. Removes Frozen, Stunned, Petrified, Plague, Suffocating, " +
		'Poisoned, Burning, Necrofire, Terrified, Silenced, Taunted, Mad.',
	arcaneStitchDetails: 'Restore 100% of maximum Magic Armour.',
	armourOfFrost: 'Armour Of Frost',
	armourOfFrostDescriptionMd:
		'Ice forms a defensive barrier around the target, providing Magic Armour. Cures Burning, Poisoned, Stunned, Frozen, Suffocating and Petrified.',
	armourOfFrostDetails: 'Set Magic Shell for 3 turn(s).',
	cleanseWounds: 'Cleanse Wounds',
	cleanseWoundsDescriptionMd: 'Heal target and create a water puddle beneath them. Remove Burning, Diseased, Decaying, Poisoned and Bleeding.',
	cleanseWoundsDetails: 'Restore some Vitality.',
	cryogenicStasis: 'Cryogenic Stasis',
	cryogenicStasisDescriptionMd:
		'Target ally enters Cryogenic Stasis. Though incapacitated, they become immune to all damage, and heal over time. Removes Shackles Of Pain.',
	cryogenicStasisDetails: 'Set Permafrost for 1 turn(s).',
	cryotherapy: 'Cryotherapy',
	cryotherapyDescriptionMd: 'Consume frozen surfaces around you and convert them to Magic Armour. Removes Burning and Necrofire.',
	cryotherapyDetails: 'Restore some Magic Armour, depending on relevant surface area.',
	deepFreeze: 'Deep Freeze',
	deepFreezeDescriptionMd:
		'Characters in the cone that are Frozen and below 10% Vitality shatter and instantly die. Otherwise they receive *Water Damage* and become Frozen.',
	deepFreezeDetails: `Instantly kill target with status Frozen below 10% Vitality.\nSet Frozen for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	globalCooling: 'Global Cooling',
	globalCoolingDescriptionMd: 'Set Chilled on enemies around you and deal *Water Damage*. Freeze all susceptible surfaces.',
	globalCoolingDetails: `Set Chilled for 3 turn(s).\n${bonusFromLevelAndIntelligence}`,
	hailStorm: 'Hail Storm',
	hailStormDescriptionMd: '20 ice shards rain from the sky, each dealing *Water Damage* to characters within {range}m range from impact.',
	hailStormDetails: `Set Chilled for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	hailStrike: 'Hail Strike',
	hailStrikeDescriptionMd: 'Icicles fall from the sky, chilling characters and dealing *Water Damage*. They create Ice surfaces where they hit the ground.',
	hailStrikeDetails: `Set Chilled for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	healingRitual: 'Healing Ritual',
	healingRitualDescriptionMd: 'Send a wave of healing to target another character. The wave travels to nearby allies, healing with each movement.',
	healingRitualDetails: 'Restore some Vitality.',
	healingTears: 'Healing Tears',
	healingTearsDescriptionMd:
		'The earth itself laments your plight, crying curative tears which heal all allies that move close to you for aid up to three times.',
	healingTearsDetails: 'Healing Tears for 3 turn(s).',
	iceBreaker: 'Ice Breaker',
	iceBreakerDescriptionMd: 'Sets off a chain reaction that causes ice areas to explode into water puddles, dealing water damage and setting Chilled.',
	iceFan: 'Ice Fan',
	iceFanDescriptionMd: 'Target 3 positions and shoot an ice shard at each one, dealing *Water Damage* and making targets Chilled.',
	iceFanDetails: `Set Chilled for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	massCleanseWounds: 'Mass Cleanse Wounds',
	massCleanseWoundsDescriptionMd:
		'Heal yourself and allies around you. Create a water puddle beneath every target. ' +
		'Remove Necrofire, Burning, Diseased, Decaying, Poisoned, Bleeding, Suffocation and Acid.',
	massCleanseWoundsDetails: 'Restore some Vitality.',
	massCryotherapy: 'Mass Cryotherapy',
	massCryotherapyDescriptionMd:
		'Each ally consumes frozen surfaces around them, converting the frozen surfaces to Magic Armour. Removes Burning and Necrofire.',
	massCryotherapyDetails: 'Restore some Magic Armour, depending on relevant surface area.',
	rain: 'Rain',
	rainDescriptionMd: 'Create a spreading water surface which douses fires. Set Wet status on characters in the area.',
	rainDetails: 'Set Wet for 1 turn(s).',
	restoration: 'Restoration',
	restorationDescriptionMd: 'Restore Vitality of a target character. Restoration also cures Poisoned, Bleeding.',
	restorationDetails: 'Restore Vitality for 2 turn(s).',
	soothingCold: 'Soothing Cold',
	soothingColdDescriptionMd: 'Regenerate Magic Armour for all allies around caster.',
	soothingColdDetails: 'Restore Magic Armour for 3 turn(s).',
	steamLance: 'Steam Lance',
	steamLanceDescriptionMd: 'Releases a stream of Blessed Steam which heals characters in its path and removes Burning, Necrofire, Diseased and Decaying.',
	steamLanceDetails: 'Restore Vitality for 3 turn(s).',
	vampiricHunger: 'Vampiric Hunger',
	vampiricHungerDescriptionMd:
		'Set Vampiric Hunger on target character, adding 50% Life Steal for 2 turns. Life Steal heals you in proportion to the damage you deal to Vitality.',
	vampiricHungerDetails: 'Set Vampiric Hunger for 2 turn(s).',
	vampiricHungerAura: 'Vampiric Hunger Aura',
	vampiricHungerAuraDescriptionMd:
		'Set Vampiric Hunger on every ally around you, adding 50% Life Steal. Life Steal heals you in proportion to the damage you deal to Vitality.',
	vampiricHungerAuraDetails: 'Set Vampiric Hunger Aura for 2 turn(s).',
	winterBlast: 'Winter Blast',
	winterBlastDescriptionMd: 'Deal *Water Damage* and set Chilled status on enemies in the area. Freeze blood and water surfaces.',
	winterBlastDetails: `Set Chilled for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
};

const necromancer = {
	blackShroud: 'Black Shroud',
	blackShroudDescriptionMd: 'Create a cloud of cursed smoke in an area, setting Suffocating and Blind on all characters within it.',
	bloodStorm: 'Blood Storm',
	bloodStormDescriptionMd:
		'The sky is weeping red tears. Bolts of coagulated blood fall on enemy characters in the area, ' +
		'each dealing *Physical Damage* and setting Disease and Decaying. Turns water in the area into blood.',
	bloodSucker: 'Blood Sucker',
	bloodSuckerDescriptionMd: 'Target character consumes blood surfaces around them, restoring Vitality. The more blood, the more they will be healed!',
	bloodSuckerDetails: 'Restore some Vitality, depending on relevant surface area.',
	boneCage: 'Bone Cage',
	boneCageDescriptionMd: 'Increases Physical Armour with extra Physical Armour bonus for each corpse in the area around you.',
	boneCageDetails: 'Bone Cage for 3 turn(s).',
	deathWish: 'Death Wish',
	deathWishDescriptionMd:
		'Target character receives a damage bonus equal to the percentage of their missing Vitality. ' +
		'For example, a character with 30% Vitality will gain a 70% damage bonus.',
	deathWishDetails: 'Set Death Wish for {deathWish} turn(s).',
	decayingTouch: 'Decaying Touch',
	decayingTouchDescriptionMd:
		'Deal *Physical Damage* to target character. Sets Decay, so the target will take physical damage from healing spells and potions.',
	decayingTouchDetails: `Set Decaying for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	graspOfTheStarved: 'Grasp Of The Starved',
	graspOfTheStarvedDescriptionMd:
		'Undead hands rise from underground, attacking enemy characters that stand in blood surfaces and clouds. ' +
		'Deals *Physical Damage* to each character and sets Crippled.',
	graspOfTheStarvedDetails: `Set Crippled for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	infect: 'Infect',
	infectDescriptionMd:
		'Deal *Physical Damage*. Infect a target with a disease that will spread to other nearby characters. ' +
		'Diseased characters deal reduced damage with all attacks and have lowered Constitution.',
	infectDetails: `Set Infected for 2 turn(s).\n${bonusFromLevelAndIntelligence}`,
	lastRites: 'Last Rites',
	lastRitesDescriptionMd: 'Sacrifice yourself to bring an ally back to life. Deals to you, and resurrects target character with maximum Vitality.',
	lastRitesDetails: 'Set Last Rite.',
	livingOnTheEdge: 'Living On The Edge',
	livingOnTheEdgeDescriptionMd:
		"For 2 turns, your target character's Vitality cannot be reduced below 1 point, keeping them alive against all odds. " +
		'If the target is a summon, their lifetime will be prolonged for the duration.',
	livingOnTheEdgeDetails: 'Set Death Resist for 2 turn(s).',
	mosquitoSwarm: 'Mosquito Swarm',
	mosquitoSwarmDescriptionMd: 'Unleash a swarm of giant mosquitoes to suck the blood from your enemies, dealing *Physical Damage* and healing yourself.',
	mosquitoSwarmDetails: `Restore Vitality equal to damage dealt.\nSet Bleeding for {bleeding} turn(s).\n${bonusFromLevelAndIntelligence}`,
	rainingBlood: 'Raining Blood',
	rainingBloodDescriptionMd: 'Create blood surfaces. Set Bleeding on enemies. Douse fire surfaces.',
	rainingBloodDetails: 'Set Bleeding for {bleeding} turn(s).',
	raiseBloatedCorpse: 'Raise Bloated Corpse',
	raiseBloatedCorpseDescriptionMd: 'Target a corpse to raise a bloated cadaver that fights for you. It can explode, dealing Physical Damage.',
	raiseBloatedCorpseDetails: 'A Bloated Corpse will be summoned at the location of your target(s).\nBlows up your target.',
	raiseBoneWidow: 'Raise Bone Widow',
	raiseBoneWidowDescriptionMd:
		'Raise a walking pile of bones which can consume corpses to restore Vitality and receive a stacking Damage buff.',
	raiseBoneWidowDetails: bonusFromSummoning,
	shacklesOfPain: 'Shackles Of Pain',
	shacklesOfPainDescriptionMd:
		'Mark a target so that it will receive all the damage you receive. Damage transferred in this way ignores any resistances the target may have.',
	shacklesOfPainDetails: 'Set Shackles of Pain for 3 turn(s).',
	silencingStare: 'Silencing Stare',
	silencingStareDescriptionMd: 'Destroy *Magic Armour* and silence all enemies within a cone in front of you.',
	silencingStareDetails: `Set Silenced for 1 turn(s).${bonusFromLevelAndIntelligence}`,
	totemsOfTheNecromancer: 'Totems Of The Necromancer',
	totemsOfTheNecromancerDescriptionMd: 'Spawn bone totems near every enemy in the area. Bone totems have ranged attacks that deal physical damage.',
	totemsOfTheNecromancerDetails: 'A Bones Totem will be summoned at the location of your target(s).',
};

const polymorph = {
	apotheosis: 'Apotheosis',
	apotheosisDescriptionMd:
		'You take the first step towards godhood. The cost of all Source skills is modified by -3 Source Point(s). All primary attributes increased by 2.',
	apotheosisDetails: 'Set Apotheosis for 2 turn(s).',
	bullHorns: 'Bull Horns',
	bullHornsDescriptionMd:
		'Magnificent horns sprout from your forehead, making you see red. You can rush at your enemies and gore them. ' +
		'Increases Retribution ability by 1 for the duration. Incompatible with Medusa Head.',
	bullHornsDetails: 'Set Bull Horns for 4 turn(s).',
	chameleonCloak: 'Chameleon Cloak',
	chameleonCloakDescriptionMd: 'Grants you the power to blend in with any environment as if Invisible.',
	chameleonCloakDetails: 'Set Invisible for 2 turn(s). Does not break Invisibility or sneaking.',
	chickenClaw: 'Chicken Claw',
	chickenClawDescriptionMd: "Turn the target character into a chicken. Squawk! ...unless it's a Kraken.",
	chickenClawDetails: 'Set Chicken Form for 2 turn(s).',
	equalise: 'Equalise',
	equaliseDescriptionMd: 'Vitality and Armour percentages of characters in target area are summed up and redistributed equally.',
	equaliseDetails: 'Exchange Vitality percentages with target.',
	flamingSkin: 'Flaming Skin',
	flamingSkinDescriptionMd: 'Flaming Skin You get immunity to fire, but lowered resistance to water. You bleed fire.',
	flamingSkinDetails: 'Set Flaming Skin for 2 turn(s).',
	flaySkin: 'Flay Skin',
	flaySkinDescriptionMd: 'Destroy Magic Armour on target character. Set status that halves resistances.',
	flaySkinDetails: `Set Nullified Resistance for 2 turn(s).\n${bonusFromLevelAndStrength}`,
	forcedExchange: 'Forced Exchange',
	forcedExchangeDescriptionMd: 'Exchange Vitality percentages with target character.',
	forcedExchangeDetails: 'Exchange Vitality percentages with target.',
	heartOfSteel: 'Heart Of Steel',
	heartOfSteelDescriptionMd:
		'Provides Physical Armour. Your heart pumps liquid metal, creating a robust layer of Physical Armour. Restores Physical Armour each turn.',
	heartOfSteelDetails: 'Restore Physical Armour for 4 turn(s).',
	icySkin: 'Icy Skin',
	icySkinDescriptionMd: 'You get immunity to water, but lowered resistance to fire. You bleed ice.',
	icySkinDetails: 'Set Icy Skin for 2 turn(s).',
	jellyfishSkin: 'Jellyfish Skin',
	jellyfishSkinDescriptionMd: 'You get immunity to electricity, but lowered resistance to poison and earth damage. You bleed electrified water.',
	jellyfishSkinDetails: 'Set Jellyfish Skin for 2 turn(s).',
	medusaHead: 'Medusa Head',
	medusaHeadDescriptionMd: 'Snakes grow out of your head, giving you a Petrifying aura and the Petrifying Visage skill. Incompatible with Bull Horns.',
	medusaHeadDetails: 'Set Medusa Head for 2 turn(s).',
	poisonousSkin: 'Poisonous Skin',
	poisonousSkinDescriptionMd: 'You get immunity to poison and earth, but lowered resistance to air. You bleed poison.',
	poisonousSkinDetails: 'Set Poisonous Skin for 2 turn(s).',
	skinGraft: 'Skin Graft',
	skinGraftDescriptionMd: 'Reset all cooldowns. Removes Burning, Necrofire, Poisoned, Bleeding.',
	skinGraftDetails: 'Set Skin Graft.',
	spiderLegs: 'Spider Legs',
	spiderLegsDescriptionMd:
		'Spider legs burst from your back. You can create web surfaces in an area to Entangle foes. ' +
		'Walking on Webbed surfaces will make you Hasted rather than Entangled. Incompatible with Wings.',
	spiderLegsDetails: 'Set Spider Legs for 2 turn(s).',
	spreadYourWings: 'Spread Your Wings',
	spreadYourWingsDescriptionMd: 'Sprout temporary wings to fly when you move, allowing you to ignore ground surfaces. Incompatible with Spider Legs.',
	spreadYourWingsDetails: 'Set Wings for 3 turn(s).',
	summonOilyBlob: 'Summon Oily Blob',
	summonOilyBlobDescriptionMd:
		'Fling an Oil Blob at target point, dealing in the area. Oil Blob deals earth damage with melee attacks and leaves an oil puddle on death.',
	summonOilyBlobDetails: `${bonusFromLevelAndStrength}\n${bonusFromSummoning}`,
	tentacleLash: 'Tentacle Lash',
	tentacleLashDescriptionMd: 'Lash out at your opponent, dealing *Physical Damage* and setting Atrophy on them.',
	tentacleLashDetails: `Set Atrophy for 1 turn(s).\n${bonusFromLevelAndStrength}`,
	terrainTransmutation: 'Terrain Transmutation',
	terrainTransmutationDescriptionMd: 'Target two circular areas. Swap surfaces and clouds.',
};

const pyrokinetic = {
	bleedFire: 'Bleed Fire',
	bleedFireDescriptionMd:
		'Enemies will bleed fire when hit. Reduces Fire Resistance by -20%. ' +
		'Also creates a small fire surface beneath each target and ignites surfaces in the area.',
	bleedFireDetails: 'Set Bleed Fire for 3 turn(s).',
	corpseExplosion: 'Corpse Explosion',
	corpseExplosionDescriptionMd: 'Explode target corpse, dealing physical damage in the area.',
	corpseExplosionDetails: 'Blows up your target.',
	deployMassTraps: 'Deploy Mass Traps',
	deployMassTrapsDescriptionMd:
		'Throw 4 explosive traps at target locations. Each trap takes a turn to activate. When active, trap will explode when a character approaches it.',
	epidemicOfFire: 'Epidemic Of Fire',
	epidemicOfFireDescriptionMd:
		'Fire a cursed flame which will fork on impact up to 5 times, dealing *Fire Damage* and leaving a cursed fire surface in its wake.',
	epidemicOfFireDetails: `Set Necrofire for {necrofire} turn(s).\n${bonusFromLevelAndIntelligence}`,
	fireWhip: 'Fire Whip',
	fireWhipDescriptionMd: 'Long-range attack that deals *Fire Damage* damage to a single target, leaving them Blind and Burning.',
	fireWhipDetails: `Set Burning for {burning} turn(s). Set Blinded for 1 turn(s).\n${bonusFromLevelAndIntelligence}`,
	fireball: 'Fireball',
	fireballDescriptionMd: 'Hurl a fiery sphere that will explode, dealing *Fire Damage*.',
	fireballDetails: `Set Burning for {burning} turn(s).${bonusFromLevelAndIntelligence}`,
	firebrand: 'Firebrand',
	firebrandDescriptionMd: 'An aura that adds *Fire Damage* to weapon skills and attacks for all allies near you.',
	firebrandDetails: 'Set Firebrand for 2 turn(s).',
	flamingCrescendo: 'Flaming Crescendo',
	flamingCrescendoDescriptionMd: 'Curse the target to explode after one turn or on death, dealing *Fire Damage* in 3m radius.',
	flamingCrescendoDetails: 'Set Flaming Crescendo for 1 turn(s).',
	flamingTongues: 'Flaming Tongues',
	flamingTonguesDescriptionMd: 'Flaming Tongues protect you, immediately attacking approaching enemies.',
	flamingTonguesDetails: 'Set Flaming Tongues for 3 turn(s).',
	haste: 'Haste',
	hasteDescriptionMd:
		'Sets Hasted on target character. Haste increases movement speed by 2m per AP and gives an additional 1 AP per turn. ' +
		'Clears Slowed and Crippled.',
	hasteDetails: 'Set Hasted for 2 turn(s).',
	ignition: 'Ignition',
	ignitionDescriptionMd: 'Sets enemy characters around you on fire. Deals *Fire Damage* to each. Ignites all susceptible surfaces.',
	ignitionDetails: `Set Burning for {burning} turn(s).${bonusFromLevelAndIntelligence}`,
	laserRay: 'Laser Ray',
	laserRayDescriptionMd: 'Line of intense heat that deals *Fire Damage* to characters and leaves fire clouds behind.',
	laserRayDetails: `Set Burning for {burning} turn(s).\n${bonusFromLevelAndIntelligence}`,
	massCorpseExplosion: 'Mass Corpse Explosion',
	massCorpseExplosionDescriptionMd: 'Explode all corpses around you, dealing physical damage in the area.',
	massCorpseExplosionDetails: 'Blows up your target.',
	massSabotage: 'Mass Sabotage',
	massSabotageDescriptionMd: 'Explode two random grenades or arrows in the inventories of every enemy in a target circle.',
	massSabotageDetails: "Explodes 2 random arrow(s) or grenade(s) in the target's inventory.",
	masterOfSparks: 'Master Of Sparks',
	masterOfSparksDescriptionMd: 'Target character and surrounding allies receive Sparkmaster status that adds a chance of fiery Sparks to melee attacks.',
	masterOfSparksDetails: 'Set Sparkmaster for 3 turn(s).',
	meteorShower: 'Meteor Shower',
	meteorShowerDescriptionMd: '25 fireballs come crashing from the sky. Each does *Fire Damage* within a 3m range from impact.',
	meteorShowerDetails: bonusFromLevelAndIntelligence,
	peaceOfMind: 'Peace Of Mind',
	peaceOfMindDescriptionMd:
		'Target gains Clear-Minded, which increases Strength, Finesse and Intelligence by 5 and Wits by 11. ' +
		'Removes Blinded, Terrified, Charmed, Taunted, Sleeping, Enraged and Mad.',
	peaceOfMindDetails: 'Set Clear-Minded for 3 turn(s).',
	sabotage: 'Sabotage',
	sabotageDescriptionMd: 'If target character is carrying grenades or arrows, a random one explodes in their inventory.',
	sabotageDetails: "Explodes 1 random arrow(s) or grenade(s) in the target's inventory.",
	searingDaggers: 'Searing Daggers',
	searingDaggersDescriptionMd:
		'Shoot three flaming daggers at targets of your choice, ' +
		'each creating a fire surface and dealing *Fire Damage*.',
	searingDaggersDetails: `Set Burning for {burning} turn(s).\n${bonusFromLevelAndIntelligence}`,
	sparkingSwings: 'Sparking Swings',
	sparkingSwingsDescriptionMd:
		'Receive Sparkstriker status. This causes your melee attacks to create a Spark projectile that bounces off the initial target to hit the closest enemy.',
	sparkingSwingsDetails: 'Set Sparkstriker for 3 turn(s).',
	spontaneousCombustion: 'Spontaneous Combustion',
	spontaneousCombustionDescriptionMd:
		'Deal *Fire Damage* to target character. If the character is affected by Burning or Necrofire, ' +
		'remove those statuses and deal additional damage for each turn of duration remaining.',
	spontaneousCombustionDetails: bonusFromLevelAndIntelligence,
	summonFireSlug: 'Summon Fire Slug',
	summonFireSlugDescriptionMd: 'Summon a fire slug. Your fire slug can create fire surfaces and launch linear fire attacks.',
	summonFireSlugDetails: bonusFromSummoning,
	supernova: 'Supernova',
	supernovaDescriptionMd: 'Explode, creating fire surfaces and dealing *Fire Damage* in a large area around you (except areas blocked by obstacles).',
	supernovaDetails: bonusFromLevelAndIntelligence,
	throwExplosiveTrap: 'Throw Explosive Trap',
	throwExplosiveTrapDescriptionMd:
		'Throw an explosive trap at target location. Trap takes 1 turn to activate. When active, the trap will explode when a character approaches it.',
};

const scoundrel = {
	adrenaline: 'Adrenaline',
	adrenalineDescriptionMd: 'Gain 2 Action Points immediately, but lose 2 Action Points next turn. Any Action Points over your maximum are lost.',
	adrenalineDetails:
		'Can only be cast in combat.\nGain 2 Action Point(s) immediately, but lose 2 Action Point(s) next turn.\nDoes not break Invisibility or sneaking.',
	backlash: 'Backlash',
	backlashDescriptionMd: 'Jump over the enemy, landing behind their back and backstabbing them *Physical Damage*.',
	backlashDetails: `100% chance to Backstab.\n${bonusFromWeaponAndFinesse}`,
	chloroform: 'Chloroform',
	chloroformDescriptionMd: 'Damages *Magic Armor* and then tries to set Sleeping.',
	chloroformDetails: `Set Sleeping for 1 turn(s).\nDoes not break Invisibility or sneaking.${bonusFromLevelAndFinesse}`,
	cloakAndDagger: 'Cloak And Dagger',
	cloakAndDaggerDescriptionMd: 'Teleport without breaking sneaking.',
	cloakAndDaggerDetails: 'Does not break Invisibility or sneaking.',
	corruptedBlade: 'Corrupted Blade',
	corruptedBladeDescriptionMd: 'Dagger attack that deals *Physical Damage* and sets Decay and Diseased.',
	corruptedBladeDetails: `Set Decaying for 2 turn(s).\nSet Diseased for 2 turn(s).\n${bonusFromWeaponAndFinesse}`,
	daggersDrawn: 'Daggers Drawn',
	daggersDrawnDescriptionMd: 'Whirl into a barrage of 5 stabs, each dealing *Physical Damage*.',
	daggersDrawnDetails: bonusFromWeaponAndFinesse,
	fanOfKnives: 'Fan Of Knives',
	fanOfKnivesDescriptionMd: 'Fling a dagger at every enemy around you, dealing *Physical Damage*. Can backstab!',
	fanOfKnivesDetails: `Can Backstab.\n${bonusFromWeaponAndFinesse}`,
	gagOrder: 'Gag Order',
	gagOrderDescriptionMd: 'Damage *Magic Armor* on target character. Silence target.',
	gagOrderDetails: `Set Silenced for 1 turn(s).\n${bonusFromWeaponAndFinesse}`,
	mortalBlow: 'Mortal Blow',
	mortalBlowDescriptionMd: 'Deal *Physical Damage*. Damage is doubled if you are sneaking or invisible. Target is killed instantly if below 20% Vitality.',
	mortalBlowDetails: `Instantly kill target below 20% Vitality.\n${bonusFromWeaponAndFinesse}`,
	ruptureTendons: 'Rupture Tendons',
	ruptureTendonsDescriptionMd: 'Deal *Physical Damage* to target character. When they try to move, they will take piercing damage.',
	ruptureTendonsDetails: `Set Ruptured Tendons for {rupturedTendons} turn(s).\n${bonusFromWeaponAndFinesse}`,
	sawtoothKnife: 'Sawtooth Knife',
	sawtoothKnifeDescriptionMd: "Pierces the enemy's Physical Armour and directly deals Sets Bleeding if the enemy has no Physical Armour.",
	sawtoothKnifeDetails: `Set Bleeding for {bleeding} turn(s).\n${bonusFromWeaponAndFinesse}`,
	sleepingArms: 'Sleeping Arms',
	sleepingArmsDescriptionMd: "Deal *Physical Damage* and set Atrophy: your target can't use weapons or weapon skills anymore.",
	sleepingArmsDetails: `Set Atrophy for 2 turn(s).\n${bonusFromWeaponAndFinesse}`,
	terrifyingCruelty: 'Terrifying Cruelty',
	terrifyingCrueltyDescriptionMd: 'Dagger attack that deals *Physical Damage* and sets Bleeding and Terrified on target character.',
	terrifyingCrueltyDetails: `Set Bleeding for {bleeding} turn(s).\nSet Terrified for 1 turn(s).\n${bonusFromWeaponAndFinesse}`,
	throwingKnife: 'Throwing Knife',
	throwingKnifeDescriptionMd: 'Throw a knife at your opponent, dealing *Physical Damage*. Can backstab!',
	throwingKnifeDetails: `Can Backstab.\n${bonusFromWeaponAndFinesse}`,
	windUpToy: 'Wind-Up Toy',
	windUpToyDescriptionMd: 'Summon a mechanical bomber at the target point. The bomber can explode, dealing fire damage and producing a fire surface.',
	windUpToyDetails: `Does not break Invisibility or sneaking.\n${bonusFromSummoning}`,
};

const summoning = {
	acidInfusion: 'Acid Infusion',
	acidInfusionDescriptionMd: "Changes Incarnate's element to acid, unlocking Poison Dart and Acid Spores.",
	cannibalise: 'Cannibalise',
	cannibaliseDescriptionMd: 'Destroy an allied summon or totem. Receive their current Vitality, Physical Armour and Magic Armour.',
	cannibaliseDetails: "Instantly kills your target.\nRestore up to 100% of target's Vitality, Physical Armour and Magic Armour on caster.",
	conjureIncarnate: 'Conjure Incarnate',
	conjureIncarnateDescriptionMd:
		'Conjure a personal elemental that matches the ground surface its summoned onto. Your Incarnate can be buffed with Infusions. ' +
		'Once you hit Summoning ability level of 10, a colossal Incarnate Champion will answer your summons!',
	conjureIncarnateDetails: bonusFromSummoning,
	controlVoidwoken: 'Control Voidwoken',
	controlVoidwokenDescriptionMd: 'Charm target Voidwoken',
	controlVoidwokenDetails: 'Set Charmed for 2 turn(s).',
	cursedElectricInfusion: 'Cursed Electric Infusion',
	cursedElectricInfusionDescriptionMd: "Changes Incarnate's element to cursed electricity, unlocking Electric Discharge and Closed Circuit.",
	dimensionalBolt: 'Dimensional Bolt',
	dimensionalBoltDescriptionMd: 'Shoot a volatile bolt that deals *Damage of a Random Type*, and then creates a corresponding surface.',
	dimensionalBoltDetails: bonusFromLevelAndIntelligence,
	dominateMind: 'Dominate Mind',
	dominateMindDescriptionMd: 'Charm target non-allied character, causing them to join your side in combat for the duration of the status.',
	dominateMindDetails: 'Set Charmed for 2 turn(s).',
	doorToEternity: 'Door To Eternity',
	doorToEternityDescriptionMd: 'Give all summons and totems around you a status that prevents them dying from damage or disappearing when their life runs out.',
	doorToEternityDetails: 'Set Persisting for 3 turn(s).',
	electricInfusion: 'Electric Infusion',
	electricInfusionDescriptionMd: "Changes Incarnate's element to electricity, unlocking Electric Discharge.",
	elementalTotem: 'Elemental Totem',
	elementalTotemDescriptionMd:
		'Target a ground surface and conjure a totem of the corresponding element. Each turn, this totem will fire a projectile at enemies in sight.',
	elementalTotemDetails: bonusFromSummoning,
	etherealStorm: 'Ethereal Storm',
	etherealStormDescriptionMd:
		'Unpredictable projectiles from distant planes strike a target area, dealing random elemental damage to enemies or healing allies.',
	farsightInfusion: 'Farsight Infusion',
	farsightInfusionDescriptionMd: 'Unlock ranged attack for your Incarnate. Provides Magic Armour (amount depends on your level). Increases damage by 25%.',
	farsightInfusionDetails: 'Set Farsight Infusion.',
	fireInfusion: 'Fire Infusion',
	fireInfusionDescriptionMd: "Changes Incarnate's element to fire, unlocking Fireball.",
	iceInfusion: 'Ice Infusion',
	iceInfusionDescriptionMd: "Changes Incarnate's element to blessed ice, unlocking Restoration and Steam Lance.",
	necrofireInfusion: 'Necrofire Infusion',
	necrofireInfusionDescriptionMd: "Changes Incarnate's element to necrofire, unlocking Fireball and Epidemic Of Fire.",
	planarGateway: 'Planar Gateway',
	planarGatewayDescriptionMd: 'Conjure two linked gateways that allow any character to instantly travel between them up to four times.',
	poisonInfusion: 'Poison Infusion',
	poisonInfusionDescriptionMd: "Changes Incarnate's element to poison, unlocking Poison Dart.",
	powerInfusion: 'Power Infusion',
	powerInfusionDescriptionMd:
		'Unlock Whirlwind and Rush for your Incarnate. Provides Physical Armour (amount depends on your level). Increases damage by 25%',
	powerInfusionDetails: 'Set Power Infusion.',
	rallyingCry: 'Rallying Cry',
	rallyingCryDescriptionMd: 'Target character regenerates Vitality and Magic Armour according to the number of allied characters and totems in their vicinity.',
	rallyingCryDetails: 'Restore Vitality.\nRestore Magic Armour.',
	shadowInfusion: 'Shadow Infusion',
	shadowInfusionDescriptionMd: 'Incarnate learns how to go invisible and strike foes with a corrosive slash. Increases damage by 25%.',
	shadowInfusionDetails: 'Set Shadow Infusion.',
	soulMate: 'Soul Mate',
	soulMateDescriptionMd:
		'Bind yourself to target character, copying any healing or Armour restoration you receive to them. ' +
		'Clears Frozen, Stunned, Knocked Down, and Petrified from target character.',
	soulMateDetails: 'Set Soul Mate for 3 turn(s).',
	summonCatFamiliar: 'Summon Cat Familiar',
	summonCatFamiliarDescriptionMd: 'Summons a cat familiar that will aid you in combat.',
	summonCatFamiliarDetails: bonusFromSummoning,
	summonCondor: 'Summon Condor',
	summonCondorDescriptionMd: 'Summons a condor that will aid you in combat.',
	summonCondorDetails: bonusFromSummoning,
	summonDragonling: 'Summon Dragonling',
	summonDragonlingDescriptionMd: 'Summons a Newt to help you in combat.',
	summonDragonlingDetails: bonusFromSummoning,
	summonInnerDemon: 'Summon Inner Demon',
	summonInnerDemonDescriptionMd:
		'Conjure a demon that will share their Intelligence with you and provide Magic Armour. ' +
		'Grants you power to terrify and protect yourself with demonic fists.',
	summonInnerDemonDetails: 'Set Inner Demon for 3 turn(s).',
	supercharger: 'Supercharger',
	superchargerDescriptionMd: 'Target totem or summon deals 100% more base damage during its next turn, but then dies.',
	superchargerDetails: 'Set Supercharged for 2 turn(s).',
	warpInfusion: 'Warp Infusion',
	warpInfusionDescriptionMd: 'Incarnate learns a teleport skill, and a skill to swap places with its master. Increases damage by 25%.',
	waterInfusion: 'Water Infusion',
	waterInfusionDescriptionMd: "Changes Incarnate's element to water, unlocking Restoration.",
};

const warfare = {
	batteringRam: 'Battering Ram',
	batteringRamDescriptionMd:
		'Rush forward in a straight line, to a designated point, hitting all enemies in your path with *Physical Damage* and setting Knockdown.',
	batteringRamDetails: `Set Knocked Down for 1 turn(s).\n${bonusFromWeaponAndAttribute}`,
	battleStomp: 'Battle Stomp',
	battleStompDescriptionMd:
		'Smash your weapon into the ground, knocking down non-allied characters in front of you, and dealing *Physical Damage*. ' +
		'Also clears non-cursed surfaces and clouds.',
	battleStompDetails: `Set Knocked Down for 1 turn(s).\n${bonusFromWeaponAndAttribute}`,
	blitzAttack: 'Blitz Attack',
	blitzAttackDescriptionMd:
		'Jump from one target to another, hitting up to 2 targets, dealing *Physical Damage* to each. Targets are chosen randomly in a 10m radius.',
	blitzAttackDetails: bonusFromWeaponAndAttribute,
	bouncingShield: 'Bouncing Shield',
	bouncingShieldDescriptionMd: 'Throw your shield at an enemy dealing *Physical Damage*. Shield can bounce to another enemy in 5m range.',
	bouncingShieldDetails: 'Damage is based on the Physical Armour of your shield.',
	challenge: 'Challenge',
	challengeDescriptionMd:
		'Mark target enemy. If they die in the next 2 turns, you are healed and receive damage and Armour bonuses. ' +
		'If target survives, they receive the bonuses and caster receives damage.',
	challengeDetails: 'Apply Challenged to a target, betting whether they will be dead in 2 turn(s).',
	cripplingBlow: 'Crippling Blow',
	cripplingBlowDescriptionMd: 'Cripple the target with a sweeping blow, and all characters around it. Deals *Physical Damage*.',
	cripplingBlowDetails: `Set Crippled for 1 turn(s).\n${bonusFromWeaponAndAttribute}`,
	deflectiveBarrier: 'Deflective Barrier',
	deflectiveBarrierDescriptionMd:
		'Projectiles that hit you are reflected back at the caster. This does not prevent the original projectile effects. Provides Physical Armour.',
	deflectiveBarrierDetails: 'Set Deflecting for 3 turn(s).',
	enrage: 'Enrage',
	enrageDescriptionMd:
		'Motivate an allied character with the power of rage. Target allied character is guaranteed to land critical hits with basic attacks and weapon skills, ' +
		'but is muted. Clears Taunted, Terrified, Charmed and Clear-Minded statuses.',
	enrageDetails: 'Set Enraged for 1 turn(s).',
	guardianAngel: 'Guardian Angel',
	guardianAngelDescriptionMd: 'Allies in melee range redirect 50% of received damage to you.',
	guardianAngelDetails: 'Set Guardian Angel Aura for 2 turn(s).',
	onslaught: 'Onslaught',
	onslaughtDescriptionMd: 'Attack 5 times with astonishing speed, each hit dealing *Physical Damage*.',
	onslaughtDetails: bonusFromWeaponAndAttribute,
	overpower: 'Overpower',
	overpowerDescriptionMd:
		"Deal *Physical Damage*. If your Physical Armour is higher than your opponent's, destroy all their Physical Armour. Can set Knocked Down.",
	overpowerDetails: ` Set Knocked Down for 1 turn(s).\n${bonusFromWeaponAndAttribute}`,
	phoenixDive: 'Phoenix Dive',
	phoenixDiveDescriptionMd: 'Leap through the air towards a target position, creating a fire surface upon landing.',
	provoke: 'Provoke',
	provokeDescriptionMd: 'Taunt the enemies around you. Provoke and tease them so that they want to attack you.',
	provokeDetails: 'Set Taunted for 1 turn(s).',
	thickOfTheFight: 'Thick Of The Fight',
	thickOfTheFightDescriptionMd: 'Gain a 10% damage boost for every nearby character or totem (including yourself). The more the merrier!',
	thickOfTheFightDetails: 'Set Thick of the Fight for 2 turn(s).',
	whirlwind: 'Whirlwind',
	whirlwindDescriptionMd: 'Perform a whirlwind attack, hitting enemies around you for *Physical Damage*.',
	whirlwindDetails: bonusFromWeaponAndAttribute,
};

const equipment = {
	allIn: 'All In',
	allInDescriptionMd: 'Perform a heavy attack that deals *Physical Damage*.',
	allInDetails: bonusFromWeaponAndAttribute,
	flurry: 'Flurry',
	flurryDescriptionMd: 'Perform three quick attacks, each dealing *Physical Damage*.',
	flurryDetails: bonusFromWeaponAndAttribute,
	shieldsUp: 'Shields Up',
	shieldsUpDescriptionMd: 'Restore the Physical Armour and Magic Armour of your shield.',
	shieldsUpDetails: 'Restore some Physical Armour.\nRestore some Magic Armour.',
	staffOfMagus: 'Staff of Magus',
	staffOfMagusDescriptionMd: 'Launch a magical missile from your staff that deals *Elemental Damage*.',
	staffOfMagusDetails: bonusFromWeaponAndAttribute,
	suckerPunch: 'Sucker Punch',
	suckerPunchDescriptionMd: 'An unexpected blow, that deals *Physical Damage* and knocks down target.',
	suckerPunchDetails: 'Set Knocked Down for 1 turn(s).',
};

const innate = {
	blindingSquall: 'Blinding Squall',
	blindingSquallDescriptionMd: 'A storm approaches and strong winds rise. They Blind and deal *Air Damage* to enemies in the target area.',
	blindingSquallDetails: 'Set Blinded for 1 turn(s).',
	breakTheShackles: 'Break The Shackles',
	breakTheShacklesDescriptionMd:
		'Remove the following negative statuses from yourself: ' +
		'Silenced, Slowed, Crippled, Chilled, Shocked, Plague, Suffocating, Atrophy, Diseased, Infectious Diseased, and Shackles of Pain.',
	demonicStare: 'Demonic Stare',
	demonicStareDescriptionMd: 'Drain *Magic Armour* from target character and gain that amount for yourself.',
	demonicStareDetails: 'Restore Magic Armour equal to damage dealt.',
	domeOfProtection: 'Dome Of Protection',
	domeOfProtectionDescriptionMd: 'Create a magical field that restores Magic and Physical Armour and increases elemental resistances on allies in an area.',
	domeOfProtectionDetails: 'Restore some Physical Armour and some Magic Armour.',
	dragonsBlaze: "Dragon's Blaze",
	dragonsBlazeDescriptionMd: 'Breathe flames in a cone, dealing *Fire Damage* and leaving fire surface behind.',
	dragonsBlazeDetails: 'Set Burning for {burning} turn(s).',
	encourage: 'Encourage',
	encourageDescriptionMd: 'Encourage allies around you, increasing their primary attributes.',
	encourageDetails: 'Set Encouraged for 3 turn(s).',
	fleshSacrifice: 'Flesh Sacrifice',
	fleshSacrificeDescriptionMd:
		'Gain 1 Action Point immediately and a 10% damage boost for 2 turns at the cost of some Constitution. ' +
		'Any Action Points over your maximum are lost.',
	maddeningSong: 'Maddening Song',
	maddeningSongDescriptionMd:
		'Sing, causing enemies in the target area to become Mad. Maddened characters will attack those nearest them, regardless of alignment.',
	maddeningSongDetails: 'Set Mad for 1 turn(s).',
	petrifyingTouch: 'Petrifying Touch',
	petrifyingTouchDescriptionMd: 'Turn a nearby target to stone, incapacitating it. Deal *Earth Damage*. Removes Bleeding, Burning, Poisoned, and Crippled.',
	petrifyingTouchDetails: 'Set Petrified for 1 turn(s).',
	playDead: 'Play Dead',
	playDeadDescriptionMd: "Fool enemies into thinking you're dead. Cooldown of skills will be paused. Any action you take will cancel this status.",
	playDeadDetails: 'Set Playing Dead for 3 turn(s).\nDoes not break Invisibility or sneaking.',
	summonIfansSoulWolf: "Summon Ifan's Soul Wolf",
	summonIfansSoulWolfDescriptionMd: 'Summons your trusty Soul Wolf, which can Howl and Bite enemies.',
	summonIfansSoulWolfDetails: bonusFromSummoning,
	timeWarp: 'Time Warp',
	timeWarpDescriptionMd: 'Target a character. Whenever this character ends a turn in combat, they immediately get a free turn.',
	timeWarpDetails: 'Receive an extra turn in combat for 1 turn(s).',
};

const source = {
	bless: 'Bless',
	blessDescriptionMd: 'Bless target character or surface.',
	blessDetails: 'Set Blessed for 2 turn(s).',
};

const story = {
	deafeningShriek: 'Deafening Shriek',
	deafeningShriekDescriptionMd: 'Remove Magic Armour from enemies around you and set Deaf, reducing Wits, Accuracy and Dodging.',
	deafeningShriekDetails: 'Set Deaf for 2 turn(s).',
};

export const skill = {
	aerotheurge, geomancer, huntsman, hydrosophist, necromancer,
	polymorph, pyrokinetic, scoundrel, summoning, warfare,
	equipment, innate, source, story,
};
